import { Button } from '@apollo/orbit';
import React from 'react';

import { isMinLengthArray } from 'src/lib/isMinLengthArray';

import { SUPERGRAPH_SCHEMA_ID } from './constants';

export function SubgraphTabBar({
  schemaNames,
  selectedSchema,
  setSelectedSchema,
}: {
  schemaNames: string[];
  selectedSchema: string;
  setSelectedSchema: (schemaName: string) => void;
}) {
  if (!isMinLengthArray(2, schemaNames)) {
    return null;
  }
  return (
    <div className="flex">
      <div className="flex w-0 flex-1 items-center gap-2 overflow-x-scroll">
        {schemaNames
          .sort((a) => (a === SUPERGRAPH_SCHEMA_ID ? -1 : 0)) // always put supergraph first
          .map((subgraphName) => (
            <Button
              variant="hidden"
              onClick={() => setSelectedSchema(subgraphName)}
              key={subgraphName}
              isActive={selectedSchema === subgraphName}
              className="inline-block h-10 flex-none whitespace-nowrap text-base font-normal text-secondary hover:text-primary focus:rounded-md focus-visible:ring-2"
            >
              {subgraphName === SUPERGRAPH_SCHEMA_ID
                ? 'Supergraph'
                : subgraphName}
            </Button>
          ))}
      </div>
    </div>
  );
}
